import { render, staticRenderFns } from "./shoutAddNum.vue?vue&type=template&id=1f32edfb&scoped=true"
import script from "./shoutAddNum.vue?vue&type=script&lang=js"
export * from "./shoutAddNum.vue?vue&type=script&lang=js"
import style0 from "./shoutAddNum.vue?vue&type=style&index=0&id=1f32edfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f32edfb",
  null
  
)

export default component.exports